import { render, staticRenderFns } from "./BaseDialogWindow.vue?vue&type=template&id=b6e87336&scoped=true&"
import script from "./BaseDialogWindow.vue?vue&type=script&lang=js&"
export * from "./BaseDialogWindow.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialogWindow.vue?vue&type=style&index=0&id=b6e87336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e87336",
  null
  
)

export default component.exports